import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { NormalText } from "../../../../components/TextParts";

export default function MeetingUrl({ url }) {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  const handleTooltipOpen = () => {
    setOpen(true);
    if (url) {
      navigator.clipboard.writeText(String(url));
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setOpen(false);
    }, 1500);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <Box sx={{ pb: "10px", display: "flex", gap: "5px" }}>
      <Box sx={{ overflowX: "scroll", flexShrink: 1 }}>
        <NormalText text={url} sx={{ whiteSpace: "nowrap" }} />
      </Box>
      <Tooltip
        PopperProps={{ disablePortal: true }}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title="コピーしました"
        placement="right"
        arrow
      >
        <IconButton onClick={handleTooltipOpen} size="small">
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}